import * as apiFactory from "@/services/ApiFactory";

import type Activity from "@/models/Activity";
import type { Dictionary } from "@/models/Helpers";
import type { PagedData } from "@/models/PagedData";

export async function getActivityTotals(
  clientName: string,
  query: Dictionary<string> = {},
): Promise<Dictionary<number>> {
  const url = `api/activity/total/${clientName}`;

  const apiClient = await apiFactory.WithoutBearer();
  return apiClient.post(url, query);
}

export async function getActivities(
  clientName: string,
  query: Dictionary<string> = {},
): Promise<PagedData<Activity[]>> {
  const url = `api/activity/${clientName}`;

  const apiClient = await apiFactory.WithoutBearer();
  return apiClient.getWithObject(url, query);
}
